import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ButtonHeading, CommonDateRange } from "components";
import "../Fastags/Fastags.css";
import { constant } from 'constants/constant';
import Tab from "components/common/Tab";
import DebitTab from "../Tabs/DebitTab";
import { getfastagDetailsApi } from "_services";
import { StorageServices } from "utils";
import moment from "moment";
import useDocumentTitle from "hooks/useDocumentTitle";
import { API, AppConfig } from "lib";
import toast from "react-hot-toast";
import { ConfirmModalFor } from "modals";

const FastagDetails = () => {
    let { id } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tabFromQuery = parseInt(queryParams.get('tab')) || 1;
    let isToken = localStorage.getItem("token");
    useDocumentTitle("Fastag Details | T360");
    const [activeTab, setActiveTab] = useState(tabFromQuery);
    const [activeTransactionTab, setActiveTransactionTab] = useState(0);
    const companyId = StorageServices.getCompanyId();
    const [fastagDetails, setFastagDetails] = useState({});
    const [loading, setLoading] = useState(false);
    const [excelLoading, setExcelLoading] = useState(false);
    const [selectedRange, setSelectedRange] = useState({
        startDate: "",
        endDate: "",
    });

    const [selectedRangeReport, setSelectedRangeReport] = useState({
        startDate: "",
        endDate: "",
    });

    const [openDate, setOpenDate] = useState(false)


    const [filter, setFilter] = useState({
        start_date: "",
        end_date: "",
        search: "",
        limit: 25,
        offset: 1,
        txntype: "",
        trip_relation: 0
    });

    const fastagDetailsHandle = async (fastagId) => {
        setLoading(true);

        const payload = {
            company_id: companyId,
            fastag_number: fastagId,
            start_date: filter.start_date,
            end_date: filter.end_date,
            // start_date:"",
            // end_date:"",
            search: filter.search,
            limit: filter.limit,
            offset: filter.offset,
            txntype: activeTab == 2 ? "D" : activeTab == 3 ? "C" : "",
            trip_relation: filter?.trip_relation
        };

        try {
            const res = await getfastagDetailsApi(payload);
            if (res?.responseCode === 200) {
                setFastagDetails(res?.data);
            }
        } catch (error) {
            console.error("Error fetching fastag details:", error);
        } finally {
            setLoading(false);
        }
    };

    const tabProps = {
        tabList: constant.fastDetailsTabs,
        activeTab: activeTab,
        callBackTab: (e) => {
            setActiveTab(e);
        },
    };

    // Handle status change
    const handleStatusChange = async () => {
        fastagDetailsHandle(id);
    };

    const DebitTabprops = {
        fastagDetails,
        filter,
        setFilter,
        setSelectedRange,
        selectedRange,
        loading,
        activeTransactionTab,
        setActiveTransactionTab,
        onStatusChange: handleStatusChange
    };

    useEffect(() => {
        if (id) {
            fastagDetailsHandle(id);
        }
    }, [id, filter.start_date, filter.end_date, filter.search, filter.offset, activeTab, filter?.trip_relation]);

    const exportHandle = async () => {
        const { startDate, endDate } = selectedRangeReport;

        // ❌ Empty check
        if (!startDate || !endDate) {
            toast.error("Please select Date Range");
            return;
        }

        // ❌ Invalid date check
        const start = new Date(startDate);
        const end = new Date(endDate);

        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
            toast.error("Invalid date selected");
            return;
        }

        // ❌ Start > End check
        if (start > end) {
            toast.error("Start date cannot be greater than end date");
            return;
        }

        // ✅ Valid case
        toast.success("Export started...");
        setExcelLoading(true);
        try {
            const payload = {
                fastag_number: id,
                start_date: moment(selectedRangeReport.startDate).format("YYYY-MM-DD"),
                end_date: moment(selectedRangeReport.endDate).format("YYYY-MM-DD"),
                is_web: true
            };
            const response = await fetch(
                `${AppConfig.api_baseurl}${API.FASTAG_REPORT_EXPORT}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Token: `${isToken}`,
                    },
                    body: JSON.stringify(payload),
                }
            );

            setOpenDate(false);
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "fastag_report.pdf";
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (error) {
            console.error(error);
            toast.error('Download failed');
        } finally {
            setExcelLoading(false);
        }
    };

    const OpenModalForDownload = () => {
        setOpenDate(false);
    }

    let confirmModalProps = {
        show: openDate,
        closeModal: (e) => {
            setOpenDate(false);
        },
        title: "Date Range",
        submitTitle: "Submit",
        onSubmit: exportHandle,
        confirmModal: "confirmModal",
    };


    const handleApply = (newRange) => {
        setSelectedRangeReport(newRange);
    };

    return (
        <>
            <ButtonHeading title="Fastag Details" />

            {/* FasTag Details Card */}

            <div className='addPr_flBx __sulpFlx_main'>
                <div className='fastag-details-card' style={{
                    background: '#fff',
                    padding: '10px 20px 1px 20px',
                    marginBottom: '8px',
                    borderRadius: '8px',
                    boxShadow: '0 1px 1px rgba(0,0,0,0.1)',
                    display: "flex",
                    justifyContent: "space-between"
                }}>
                    <div style={{ marginBottom: '16px' }}>
                        {fastagDetails?.fastag?.assigned_to_vehicle?.vehicle_no && <h3 style={{
                            fontSize: '18px',
                            fontWeight: '500',
                            marginBottom: '4px',
                            color: '#001B50'
                        }}>
                            {fastagDetails?.fastag?.assigned_to_vehicle?.vehicle_no}
                        </h3>}
                        <p style={{
                            fontSize: '14px',
                            color: '#001B50',
                            margin: 0
                        }}>
                            Fastag ID {fastagDetails?.fastag?.fastag_number || '3495783457837457'}
                        </p>
                    </div>
                    <div className="_rSideBtn" >
                        <button className="_addComm_btn" onClick={() => setOpenDate(true)}>{excelLoading ? "Downloading.." : "Download Statement"}</button>
                    </div>
                </div>
                <span style={{
                    fontSize: '14px',
                    color: '#001B50',
                    padding: '0px 20px'
                }}>
                    Transactions
                </span>
                <Tab {...tabProps} />
                {activeTab === 1 && <DebitTab {...DebitTabprops} />}
                {activeTab === 2 && <DebitTab {...DebitTabprops} />}
                {activeTab === 3 && <DebitTab {...DebitTabprops} />}
            </div>
            {openDate && (
                <ConfirmModalFor {...confirmModalProps}>
                    <>
                        <div className="_divForth">
                            <CommonDateRange
                                initialStartDate={selectedRange.startDate}
                                initialEndDate={selectedRange.endDate}
                                onApply={handleApply}
                            />
                        </div>
                    </>
                </ConfirmModalFor>
            )}
        </>
    );
};

export default FastagDetails;